import { useEffect } from 'react';
import Loading from '@/components/Loading/Loading';
import CollectionSlider from '@/components/homepage/CollectionsSlider';
import { COLLECTION_LIST } from './constants';
import { useYouMayAlsoLike } from './useYouMayAlsoLike';
import { CollectionCarouselProps } from './types';

const CollectionCarousel = ({
  sectionClasses,
  matchedCollection,
  setShouldShowCollectionCarousel,
}: CollectionCarouselProps) => {
  const pskus: Array<string> = COLLECTION_LIST[matchedCollection];
  const offers = useYouMayAlsoLike(pskus);

  useEffect(() => {
    if (offers != null && offers.length < 5)
      setShouldShowCollectionCarousel(false);
  });

  if (offers == null) {
    return (
      <div className="my-10 xxs:my-12 xs:my-14 md:my-16 lg:my-20">
        <Loading />
      </div>
    );
  }

  return (
    <>
      {offers.length > 0 && (
        <div className={sectionClasses}>
          <CollectionSlider
            title="You May Also Like"
            dealTitle="View All"
            offers={offers}
            collectionHandle={matchedCollection}
            hideViewAll
            displayPrice
          />
        </div>
      )}
    </>
  );
};

export default CollectionCarousel;
